/**
 * @voltxampere/ui — IRF540 NMOS power MOSFET variant (Sprint 38-2)
 *
 * Reference: Vishay/IRF IRF540N datasheet (TO-220 power NMOS).
 *   Vt0 = 4.0 V         (datasheet V_GS(th) typical 3-5 V)
 *   Kp  = 21 A/V²       (high transconductance — power MOSFET)
 *   Lambda = 0.01 1/V   (channel-length modulation)
 *
 * Power package: TO-220, R_th = 1.5 °C/W (Sprint 38-5 R_thermal entry).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { nmos } from "../nmos.js";
export const mosfetNmosIrf540 = {
    id: "irf540",
    nameTr: "IRF540 (NMOS güç, TO220)",
    nameEn: "IRF540 (NMOS power, TO220)",
    shortcut: "M",
    category: "active",
    viewBox: nmos.viewBox,
    terminals: nmos.terminals,
    defaultLabel: "M",
    defaultValue: "IRF540",
    schemaType: "mosfet-nmos",
    defaultParams: { Vt0: 4.0, Kp: 21, Lambda: 0.01 },
    renderSVG: () => nmos.renderSVG(),
};
//# sourceMappingURL=mosfet-nmos-irf540.js.map